import {
  DIVIDER_CHANGE_COLOR,
  DIVIDER_CHANGE_WIDTH,
  DIVIDER_CHANGE_VERTICAL_PADDING,
} from './action-names';

export function changeColor(data) {
  return {
    type: DIVIDER_CHANGE_COLOR,
    ...data
  };
};

export function changeWidth(data) {
  return {
    type: DIVIDER_CHANGE_WIDTH,
    ...data
  };
};

export function changeVerticalPadding(data) {
  return {
    type: DIVIDER_CHANGE_VERTICAL_PADDING,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/divider-element-actions.js